import { formatCardNumber } from '../../utils'

import { CardNumberInput } from '../CreditCard/CardNumberInput'

interface CardNumberInputProps {
  value: string
  theme?: any
  onChange: (value: string) => void
  isMaterialInput?: boolean
}

const CardNumberTextInput = ({ value, onChange, theme, isMaterialInput = true, testID }: CardNumberInputProps) => {
  const internalOnChange = (value: string) => {
    onChange(value.replace(/[^0-9]/g, ''))
  }

  return (
    <CardNumberInput
      theme={theme}
      cardNumber={formatCardNumber(value ?? '')}
      onSaveCardVisible={() => {}}
      onCardNumberBlur={() => {}}
      setCardNumber={internalOnChange}
      isValidCardNumber={() => {}}
      setMaxCvvLength={() => {}}
      setCurCardVendor={() => {}}
      errorColor={theme.brandColor}
      isValid={true}
      isMaterialInput={isMaterialInput}
      errMsg={''}
    />
  )
}

export { CardNumberTextInput }
